import { useContext, useEffect, useCallback } from 'react'
import { useLocation } from 'react-router'
import RootStore from '~/stores/RootStore'
import analytics from '../stores/analytics'

export const MIN_WIDTH_SMALL_SCREEN = 680
export const MIN_HEIGHT_SMALL_SCREEN = 500

export const useCheckScreenSize = () => {
  const store = useContext(RootStore)
  const location = useLocation()

  const checkScreenSize = useCallback(() => {
    const windowWidth = window.innerWidth
    const windowHeight = window.innerHeight
    const devicePixelRatio = window.devicePixelRatio

    const isSmallScreen = windowWidth < MIN_WIDTH_SMALL_SCREEN || windowHeight < MIN_HEIGHT_SMALL_SCREEN
    store?.uiStore.updateIsSmallScreen(isSmallScreen)

    analytics.setSessionContext({
      windowWidth,
      windowHeight,
      devicePixelRatio,
      isSmallScreen,
    })
  }, [store])

  useEffect(() => {
    window.addEventListener('resize', checkScreenSize)
    checkScreenSize()
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [checkScreenSize])

  useEffect(() => {
    checkScreenSize()
  }, [location.pathname, checkScreenSize])
}